import { ref, watch } from 'vue'
import { contactsService } from '../../services'

/**
 * Historique du CLIENT vu depuis une demande de devis.
 *
 * Là où `useQuoteHistory` ne montre que ce qui s'est passé sur CE devis,
 * celui-ci remonte tout ce qui s'est échangé avec la fiche « Prospect &
 * entreprise » à laquelle il appartient — donc les autres demandes, et les
 * autres personnes de la même entreprise.
 */
export function useQuoteClientHistory(email, siret) {
  const calls = ref([])
  const sentEmails = ref([])
  const upcomingEmails = ref([])
  const loading = ref(false)

  const load = async ([clientEmail, clientSiret]) => {
    if (!clientEmail) return

    loading.value = true
    try {
      const [callsResult, emailsResult, upcomingResult] = await Promise.all([
        contactsService.getCalls(clientEmail, clientSiret),
        contactsService.getAutomaticEmails(clientEmail, clientSiret),
        contactsService.getUpcomingEmails(clientEmail, clientSiret)
      ])

      calls.value = callsResult?.calls || []
      sentEmails.value = emailsResult?.emails || []
      upcomingEmails.value = upcomingResult?.upcomingEmails || []
    } catch (error) {
      console.error("Erreur lors du chargement de l'historique client:", error)
      calls.value = []
      sentEmails.value = []
      upcomingEmails.value = []
    } finally {
      loading.value = false
    }
  }

  // L'e-mail n'est connu qu'une fois la demande chargée ; le SIRET désigne
  // l'établissement quand la personne en représente plusieurs.
  watch([email, siret], load, { immediate: true })

  return { calls, sentEmails, upcomingEmails, loading }
}
